import type { PropsWithChildren } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

import { EmptyState } from "./state-fabric/EmptyState";
import { EndOfResultsState } from "./state-fabric/EndOfResultsState";
import { LoadingState } from "./state-fabric/LoadingState";

interface IAlertsFeedProps {
    isEmpty?: boolean;
    isLoading?: boolean;
}

export const AlertsFeed = ({ children, isEmpty, isLoading }: PropsWithChildren<IAlertsFeedProps>) => {
    if (isLoading) {
        return <LoadingState />;
    }

    if (isEmpty) {
        return <EmptyState />;
    }

    return (
        <Stack
            gap="16px"
            data-automation="alerts-feed"
        >
            {children}
            <EndOfResultsState />
        </Stack>
    );
};
